import {
  EXTRA_SERVICES_BOOKING,
  END_OF_TENANCY_EXTRA_SERVICES,
} from "@typings/booking";
import { EXTRA_SERVICES_B2B } from "@typings/b2b";

import {
  DresserDrawers,
  WhipOven,
  WashingMachineAppliance,
  Fridge,
  InteriorWindows,
  Shirt,
  Timer,
  FrontDoor,
  Baseboards,
  Blinds,
  Balcony,
  ForkSpoonKnife,
  CoffeeMachine,
  TextileMaterial,
} from "@ui/Assets/MyIcons";

const mapTaskToIcon = (
  task:
    | EXTRA_SERVICES_BOOKING
    | END_OF_TENANCY_EXTRA_SERVICES
    | EXTRA_SERVICES_B2B,
) => {
  const iconMap = {
    // booking
    [EXTRA_SERVICES_BOOKING.IRONING]: Shirt,
    [EXTRA_SERVICES_BOOKING.HOME_CLEANING]: Shirt,
    [EXTRA_SERVICES_BOOKING.INSIDE_CABINETS]: DresserDrawers,
    [EXTRA_SERVICES_BOOKING.INSIDE_FRIDGE]: Fridge,
    [EXTRA_SERVICES_BOOKING.INSIDE_OVEN]: WhipOven,
    [EXTRA_SERVICES_BOOKING.LAUNDRY_WASH_AND_DRY]: WashingMachineAppliance,
    [EXTRA_SERVICES_BOOKING.INTERIOR_WINDOWS]: InteriorWindows,
    [EXTRA_SERVICES_BOOKING.BONUS_15]: Timer,

    // eot
    // [END_OF_TENANCY_EXTRA_SERVICES.INSIDE_CABINETS]: DresserDrawers,
    // [END_OF_TENANCY_EXTRA_SERVICES.INSIDE_FRIDGE]: Fridge,
    // [END_OF_TENANCY_EXTRA_SERVICES.INSIDE_OVEN]: WhipOven,
    [END_OF_TENANCY_EXTRA_SERVICES.BASEBOARDS]: Baseboards,
    [END_OF_TENANCY_EXTRA_SERVICES.DOOR_HANDLES]: FrontDoor,
    // [END_OF_TENANCY_EXTRA_SERVICES.INTERIOR_WINDOWS]: InteriorWindows,
    [END_OF_TENANCY_EXTRA_SERVICES.WINDOW_BLINDS]: Blinds,
    [END_OF_TENANCY_EXTRA_SERVICES.BALCONY]: Balcony,
    [END_OF_TENANCY_EXTRA_SERVICES.END_OF_TENANCY_CLEANING]: Fridge,

    // b2b
    [EXTRA_SERVICES_B2B.B2B_CLEANING]: Fridge,
    [EXTRA_SERVICES_B2B.DISHES]: ForkSpoonKnife,
    // [EXTRA_SERVICES_B2B.INSIDE_FRIDGE]: Fridge,
    [EXTRA_SERVICES_B2B.GLASS_WALLS]: InteriorWindows,
    [EXTRA_SERVICES_B2B.COFFEE_MACHINE]: CoffeeMachine,
    [EXTRA_SERVICES_B2B.LAUNDRY]: TextileMaterial,
    [EXTRA_SERVICES_B2B.LAUNDRY_CLOTHS]: TextileMaterial,
  };

  return iconMap[task];
};

export { mapTaskToIcon };
